import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { CheckIcon, ChevronDownIcon } from "@heroicons/react/20/solid";
import {
  USER_FILTER_ALL,
  getFilterMenuOptions,
  getSelectedFilterOption,
} from "../utils/teamUsersTable";

export default function UsersTableFilterStrip({
  filters = [],
  values = {},
  onChange,
  onClear,
  showClearFilters = false,
  className = "",
}) {
  return (
    <div className={`flex flex-wrap items-center gap-y-2 ${className}`}>
      <div className="-mx-4 flex flex-wrap items-center divide-x divide-gray-200">
        {filters.map((filter) => {
          const selectedValue = values?.[filter.key] ?? filter.defaultValue;
          const selectedOption = getSelectedFilterOption(filter, selectedValue);
          const menuOptions = getFilterMenuOptions(filter, selectedValue);
          const shouldShowPill =
            selectedOption &&
            (selectedValue !== USER_FILTER_ALL || filter.showPillWhenDefault);

          return (
            <Menu as="div" key={filter.key} className="relative inline-block px-4 text-left">
              <Menu.Button
                className={`group inline-flex items-center text-sm font-medium focus:outline-none ${
                  shouldShowPill ? "text-indigo-700" : "text-gray-700 hover:text-gray-900"
                }`}
              >
                <span>{filter.label}</span>
                {shouldShowPill && (
                  <span className="ml-1.5 max-w-[160px] truncate rounded bg-indigo-100 px-1.5 py-0.5 text-xs font-medium text-indigo-700">
                    {selectedOption.label}
                  </span>
                )}
                <ChevronDownIcon
                  className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500"
                  aria-hidden="true"
                />
              </Menu.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute left-0 z-50 mt-2 max-h-80 min-w-[14rem] origin-top-left overflow-auto rounded-md border border-gray-200 bg-white p-2 shadow-2xl ring-1 ring-black/5 focus:outline-none">
                  <div className="space-y-0.5">
                    {menuOptions.map((option) => {
                      const isSelected = option.value === selectedValue;
                      return (
                        <Menu.Item key={`${filter.key}-${option.value}`}>
                          {({ close }) => (
                            <button
                              type="button"
                              onClick={() => {
                                onChange?.(filter.key, option.value);
                                close();
                              }}
                              className={`flex w-full items-center justify-between rounded px-2 py-1.5 text-left text-sm hover:bg-gray-50 ${
                                isSelected
                                  ? "bg-indigo-50 font-medium text-indigo-700"
                                  : "text-gray-700"
                              }`}
                            >
                              <span className="truncate">{option.label}</span>
                              {isSelected ? (
                                <CheckIcon className="ml-2 h-4 w-4 flex-shrink-0 text-indigo-600" aria-hidden="true" />
                              ) : (
                                <span className="ml-2 h-4 w-4" aria-hidden="true" />
                              )}
                            </button>
                          )}
                        </Menu.Item>
                      );
                    })}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          );
        })}
      </div>
      {showClearFilters && (
        <button
          type="button"
          onClick={onClear}
          className="ml-4 text-xs font-medium text-indigo-600 hover:text-indigo-800"
        >
          Clear filters
        </button>
      )}
    </div>
  );
}
